/**
 * Determines whether or not 2 things are identically the same.
 */
export function is<T>(value: unknown, comaprator: T): value is T {
  return value === comaprator;
}
